import React, { useEffect, useState } from 'react';
import { fetchJobPostingYearsForSchool, jobPostingImageUrls } from './jobPostingAsset';

type JobPostingImageProps = {
  recruitId: string;
  // 指定すると、その学校が送付先に入っている年度の求人票を優先して表示する。
  schoolId?: string;
};

// 求人票(20歳卒)のプレビュー画像。年度の優先順に候補URLを試し、
// 読み込めなければ(404等)次の候補へ切り替える。
const JobPostingImage: React.FC<JobPostingImageProps> = ({ recruitId, schoolId }) => {
  const [urls, setUrls] = useState<string[]>([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    fetchJobPostingYearsForSchool(recruitId, schoolId).then((years) => {
      if (cancelled) return;
      setUrls(jobPostingImageUrls(recruitId, years, 20));
      setIndex(0);
    });
    return () => { cancelled = true; };
  }, [recruitId, schoolId]);

  if (urls.length === 0 || index >= urls.length) return null;

  return (
    <img
      src={urls[index]}
      onError={() => setIndex((i) => i + 1)}
    />
  );
};

export default JobPostingImage;
